import getInventory from './getInventory';
import DrawModel from '@models/DrawModel';
import LotteriesEnum from '@data/lotteries';

export default async function (gameMode = null) {
  try {
    let draws = []
    let specialDraw = null

    const inventory = await getInventory()
    if (!inventory) return null

    // FOR SPECIAL LOTTERY by env file
    if (FORCE_SPECIAL_LOTTERY) {
      specialDraw = (inventory.portalDrawsOnSale || [])
        .filter((a) => a.drawDate)
        .find((a) => a.lotteryID === FORCE_SPECIAL_LOTTERY)
    } else {
      specialDraw = (inventory.portalDrawsOnSale || [])
        .filter((a) => a.drawDate)
        .find((a) => a.isEspecial === true)
    }

    if (!gameMode) {
      draws = draws
        .concat(
          inventory.portalDrawsOnSale || [],
          inventory.customDrawsOnSale || []
        )
        .sort((a, b) => {
          return a.drawDate > b.drawDate || (a.drawDate === b.drawDate) - 1
        }) // set next custom and products
        .map((draw) => {
          draw.hasProductsAvailable = !!inventory.productsOnSale.find(
            (a) =>
              a.drawNumber === draw.drawNumber && a.lotteryID === draw.lotteryID
          )
          draw.hasCustomGameAvailable = !!inventory.customDrawsOnSale.find(
            (a) =>
              a.drawNumber === draw.drawNumber && a.lotteryID === draw.lotteryID
          )
          draw.hasOffers = !!inventory.productsOnSale.find(
            (a) =>
              a.isEspecialOffer &&
              a.drawNumber === draw.drawNumber &&
              a.lotteryID === draw.lotteryID
          )
          return draw
        })
    }

    const obj = {
      total: 0,
      gameMode: gameMode,
      special: null,
      draws: {
        today: [],
        tomorrow: [],
        next: []
      }
    }

    if (specialDraw) {
      obj.special = new DrawModel(specialDraw)
    }

    let lotCount = 0
    const lotteriesEnum = JSON.parse(JSON.stringify(LotteriesEnum))

    if (obj.special) {
      obj.special.lottery = lotteriesEnum.find(
        (a) => a.special === true && a.id === obj.special.lotteryID
      )

      if (!obj.special.lottery) {
        obj.special.lottery = lotteriesEnum.find(
          (a) => a.special === false && a.id === obj.special.lotteryID
        )
      }
    }

    lotteriesEnum.forEach((lottery) => {
      if (lottery.special || lotCount > 10 || !lottery.showInFront) {
        return
      }

      const nextDraw = draws.find(
        (a) => a.isEspecial === false && a.lotteryID === lottery.id
      )

      if (nextDraw || !gameMode) {
        lotCount++
        lottery.nextDraw = new DrawModel(nextDraw)

        lottery.hasNextdrawBolaoToBuy = false
        lottery.hasNextdrawCustomToBuy = false

        switch (lottery.nextDraw.drawDateText) {
          case 'Hoje':
            obj.draws.today.push(lottery)
            break
          case 'Amanhã':
            obj.draws.tomorrow.push(lottery)
            break
          default:
            // remove common lotteries with special lottery active when common lottery haven'n next draw registered

            if (
              obj.special &&
              obj.special.lottery &&
              obj.special.lottery.id === lottery.id &&
              lottery.nextDraw &&
              lottery.nextDraw.drawNumber
            ) {
              obj.draws.next.push(lottery)
            }

            // add all if isn't a current special lottery
            if (
              obj.special &&
              obj.special.lottery &&
              obj.special.lottery.id !== lottery.id
            ) {
              obj.draws.next.push(lottery)
            }

            if (!obj.special) {
              obj.draws.next.push(lottery)
            }

            break
        }
      }
    })

    obj.total = lotCount
    return obj
  } catch (err) {
    console.error(err)
    return new Error(err);
  }
}
